(() => {
 if(customElements.get('ala-section-nav')) return;
 class AlaSectionNav extends HTMLElement {
  connectedCallback(){
   this.abort?.abort(); this.abort=new AbortController();
   this.links=[...this.querySelectorAll('a[href^="#"]')];
   this.items=this.links.map(link=>({link,target:document.getElementById(link.hash.slice(1))})).filter(item=>item.target);
   if(!this.items.length)return;
   const setActive=link=>this.links.forEach(a=>a===link?a.setAttribute('aria-current','location'):a.removeAttribute('aria-current'));
   this.update=()=>{this.frame=null;const ordered=[...this.items].sort((a,b)=>a.target.getBoundingClientRect().top-b.target.getBoundingClientRect().top);let current=ordered[0];for(const item of ordered){if(item.target.getBoundingClientRect().top<=150)current=item;}setActive(current.link);};
   const options={signal:this.abort.signal};
   this.links.forEach(link=>link.addEventListener('click',event=>{
    const item=this.items.find(item=>item.link===link);if(!item||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
    event.preventDefault();setActive(link);history.replaceState(null,'',link.hash);
    item.target.setAttribute('tabindex','-1');item.target.focus({preventScroll:true});
    item.target.scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
   },options));
   const queue=()=>{if(!this.frame)this.frame=requestAnimationFrame(this.update);};
   window.addEventListener('scroll',queue,{passive:true,signal:this.abort.signal});window.addEventListener('resize',queue,options);window.addEventListener('hashchange',queue,options);this.update();
  }
  disconnectedCallback(){this.abort?.abort();cancelAnimationFrame(this.frame);}
 }
 customElements.define('ala-section-nav',AlaSectionNav);
})();
